function handleCollectionFilters() {
  if (!/\/collections\//.test(window.location.pathname)) {
    return;
  }

  let transitionCSS = null;
  const TRANSITION_DURATION = 600;

  function injectTransitionCSS() {
    if (transitionCSS) {
      return;
    }

    const style = document.createElement('style');

    style.textContent = `
      .boost-sd__filter-option-itemwrapper {
        transition: height ${TRANSITION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1) !important;
        overflow: hidden !important;
      }

      .filter-see-more-btn {
        background: none;
        border: none;
        color: inherit;
        cursor: pointer;
        text-decoration: underline;
        font-size: 0.875rem;
        padding: 0.5rem 0;
        margin-top: 0.25rem;
        width: 100%;
        text-align: left;
      }

      .filter-see-more-btn:hover {
        opacity: 0.7;
      }
    `;

    document.head.appendChild(style);
    transitionCSS = style;
  }

  function injectFilterTitle() {
    const filterContent = document.querySelector('.boost-sd__filter-tree-vertical-content');

    if (!filterContent) {
      return false;
    }

    // Check if title already exists
    const existingTitle = filterContent.querySelector('.sidebar-section-title');

    if (existingTitle) {
      return true;
    }

    // Create the h3 title
    const filterTitle = document.createElement('h3');
    filterTitle.className = 'sidebar-section-title';
    filterTitle.textContent = 'Filter';

    // Insert as first child
    filterContent.insertBefore(filterTitle, filterContent.firstChild);

    return true;
  }

  function handleSeeMoreButtons() {
    const filterLists = document.querySelectorAll('.boost-sd__filter-option-listitem');

    filterLists.forEach((ul, index) => {
      if (ul.dataset.seeMoreProcessed) {
        return;
      }

      const allItems = ul.querySelectorAll('li');

      if (allItems.length === 0) {
        watchForListItems(ul, index + 1);

        return;
      }

      const visibleItems = Array.from(allItems).filter(item => getComputedStyle(item).display !== 'none');

      if (visibleItems.length > 5) {
        // Mark all originally visible items before we start hiding any
        allItems.forEach(item => {
          const isOriginallyVisible = getComputedStyle(item).display !== 'none';
          item.dataset.originallyVisible = isOriginallyVisible.toString();
          item.dataset.manuallyHidden = 'false';
        });

        ul.dataset.seeMoreProcessed = 'true';
        ul.dataset.visibleCount = '5';
        ul.dataset.totalVisibleItems = visibleItems.length.toString();

        updateVisibilityForVisibleItems(ul, 5);
        createSeeMoreButton(ul);

        // Watch for DOM reordering by Boost
        watchForDOMReordering(ul);
      } else {
        ul.dataset.seeMoreProcessed = 'true';
      }
    });
  }

  function watchForListItems(ul) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const addedLiElements = Array.from(mutation.addedNodes).filter(node => node.tagName === 'LI');

          if (addedLiElements.length > 0) {
            observer.disconnect();

            const allItems = ul.querySelectorAll('li');
            const visibleItems = Array.from(allItems).filter(item => getComputedStyle(item).display !== 'none');

            if (visibleItems.length > 5) {
              // Mark all originally visible items, but exclude empty bracket items
              allItems.forEach(item => {
                const isCurrentlyVisible = getComputedStyle(item).display !== 'none';

                const hasEmptyBrackets =
                  item.querySelector('.boost-sd__filter-option-item-label')?.textContent?.trim() === '[]';

                // Item is originally visible if it's currently visible AND doesn't have empty brackets
                const isOriginallyVisible = isCurrentlyVisible && !hasEmptyBrackets;

                item.dataset.originallyVisible = isOriginallyVisible.toString();
                item.dataset.manuallyHidden = 'false';

                // Hide empty bracket items immediately
                if (hasEmptyBrackets) {
                  item.style.display = 'none';
                }
              });

              // Recalculate visible items count excluding empty brackets
              const actualVisibleItems = Array.from(allItems).filter(item => item.dataset.originallyVisible === 'true');

              ul.dataset.seeMoreProcessed = 'true';
              ul.dataset.visibleCount = '5';
              ul.dataset.totalVisibleItems = actualVisibleItems.length.toString();

              updateVisibilityForVisibleItems(ul, 5);
              createSeeMoreButton(ul);

              // Watch for DOM reordering by Boost
              watchForDOMReordering(ul);
            } else {
              ul.dataset.seeMoreProcessed = 'true';
            }
          }
        }
      });
    });

    observer.observe(ul, {
      childList: true,
      subtree: true,
    });
  }

  function updateVisibilityForVisibleItems(ul, visibleCount) {
    const allItems = ul.querySelectorAll('li');

    // Get items that should be considered for visibility (originally visible, not empty brackets)
    const eligibleItems = Array.from(allItems).filter(item => {
      const wasOriginallyVisible = item.dataset.originallyVisible === 'true';
      const hasEmptyBrackets = item.querySelector('.boost-sd__filter-option-item-label')?.textContent?.trim() === '[]';

      return wasOriginallyVisible && !hasEmptyBrackets;
    });

    // Show/hide based on current DOM order (after any Boost reordering)
    eligibleItems.forEach((item, index) => {
      if (index < visibleCount) {
        item.style.display = '';
        item.dataset.manuallyHidden = 'false';
      } else {
        item.style.display = 'none';
        item.dataset.manuallyHidden = 'true';
      }
    });

    // Ensure empty bracket items stay hidden
    Array.from(allItems).forEach(item => {
      const hasEmptyBrackets = item.querySelector('.boost-sd__filter-option-item-label')?.textContent?.trim() === '[]';

      if (hasEmptyBrackets) {
        item.style.display = 'none';
      }
    });
  }

  function watchForDOMReordering(ul) {
    // Store the initial order of items
    let lastItemOrder = Array.from(ul.querySelectorAll('li')).map(item => {
      const label = item.querySelector('.boost-sd__filter-option-item-label')?.textContent?.trim();

      return label || '';
    });

    const reorderObserver = new MutationObserver(mutations => {
      let hasReordered = false;

      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
          // Check if the order has changed
          const currentItemOrder = Array.from(ul.querySelectorAll('li')).map(item => {
            const label = item.querySelector('.boost-sd__filter-option-item-label')?.textContent?.trim();

            return label || '';
          });

          // Compare orders - only trigger if there's an actual meaningful change
          const lengthChanged = currentItemOrder.length !== lastItemOrder.length;
          const orderChanged = currentItemOrder.some((label, index) => label !== lastItemOrder[index]);

          if (lengthChanged || orderChanged) {
            // This is likely Boost reconstructing the DOM, not just reordering
            // We need to re-establish our "see more" functionality
            const isBoostReconstruction = Math.abs(currentItemOrder.length - lastItemOrder.length) > 10;

            if (isBoostReconstruction) {
              // Re-establish the see more functionality for this list
              setTimeout(() => {
                reEstablishSeeMoreForList(ul);
              }, 200);
            } else {
              hasReordered = true;
            }

            lastItemOrder = currentItemOrder;
          }
        }
      });

      if (hasReordered) {
        // Reapply our visibility logic based on current visible count
        const currentVisibleCount = parseInt(ul.dataset.visibleCount || '5');

        // Small delay to let Boost finish its work
        setTimeout(() => {
          updateVisibilityForVisibleItems(ul, currentVisibleCount);
        }, 100);
      }
    });

    reorderObserver.observe(ul, {
      childList: true,
      // Only watch direct children (li elements)
      subtree: false,
    });
  }

  function createSeeMoreButton(ul) {
    /* eslint-disable no-console */
    const currentVisible = parseInt(ul.dataset.visibleCount || '5');

    const total = parseInt(ul.dataset.totalVisibleItems || ul.querySelectorAll('li').length);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'filter-see-more-btn';

    updateButtonText(button, currentVisible, total);

    button.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      const currentCount = parseInt(ul.dataset.visibleCount);
      const totalCount = parseInt(ul.dataset.totalVisibleItems);

      const newVisible = Math.min(currentCount + 10, totalCount);

      updateVisibilityForVisibleItems(ul, newVisible);
      ul.dataset.visibleCount = newVisible.toString();

      if (newVisible >= totalCount) {
        console.log('  🗑️ All items shown - removing button');
        button.remove();
      } else {
        updateButtonText(button, newVisible, totalCount);
      }

      const wrapper = ul.closest('.boost-sd__filter-option-itemwrapper');

      if (wrapper && !wrapper.classList.contains('boost-sd__filter-option-itemwrapper--collapsed')) {
        setTimeout(() => {
          calculateHeight(wrapper);
        }, 10);
      }
    });

    ul.parentNode.insertBefore(button, ul.nextSibling);
    /* eslint-enable no-console */
  }

  function updateButtonText(button, visible, total) {
    const remaining = total - visible;

    if (remaining <= 10) {
      button.textContent = `see ${remaining} more`;
    } else {
      button.textContent = 'see 10 more';
    }
  }

  function calculateHeight(wrapper) {
    const isCollapsed = wrapper.classList.contains('boost-sd__filter-option-itemwrapper--collapsed');
    const currentHeight = wrapper.style.height;

    if (isCollapsed) {
      // Collapsing: animate from current height to 0
      if (currentHeight !== '0px') {
        if (currentHeight === 'auto' || !currentHeight) {
          // Need to get current height first - temporarily remove collapsed class
          wrapper.classList.remove('boost-sd__filter-option-itemwrapper--collapsed');
          const naturalHeight = wrapper.scrollHeight;
          wrapper.classList.add('boost-sd__filter-option-itemwrapper--collapsed');

          wrapper.style.height = `${naturalHeight}px`;

          // Force reflow
          wrapper.offsetHeight;

          requestAnimationFrame(() => {
            wrapper.style.height = '0px';
          });
        } else {
          // Already has pixel height, just animate to 0
          wrapper.style.height = '0px';
        }
      }
    } else {
      // Expanding: animate from 0 or current height to natural height
      const naturalHeight = wrapper.scrollHeight;

      if (currentHeight === '0px') {
        // Expanding from collapsed state - animate from 0 to natural height
        requestAnimationFrame(() => {
          wrapper.style.height = `${naturalHeight}px`;
        });
      } else if (currentHeight === 'auto' || !currentHeight) {
        // Currently auto, set explicit height for consistency
        wrapper.style.height = `${naturalHeight}px`;
      } else {
        // Has some other height, animate to natural height
        wrapper.style.height = `${naturalHeight}px`;
      }

      // After transition, set back to auto (but disable observer temporarily)
      setTimeout(() => {
        if (!wrapper.classList.contains('boost-sd__filter-option-itemwrapper--collapsed')) {
          // Temporarily stop observing this wrapper
          wrapper.dataset.heightTransitioning = 'true';
          wrapper.style.height = 'auto';

          // Re-enable observation after a brief delay
          setTimeout(() => {
            delete wrapper.dataset.heightTransitioning;
          }, 50);
        }
      }, TRANSITION_DURATION + 50);
    }
  }

  function reEstablishSeeMoreForList(ul) {
    // Remove any existing see more button
    const existingButton = ul.parentNode.querySelector('.filter-see-more-btn');

    if (existingButton) {
      existingButton.remove();
    }

    // Clear previous processing markers
    ul.dataset.seeMoreProcessed = '';

    // Get all current items
    const allItems = ul.querySelectorAll('li');

    if (allItems.length <= 5) {
      return;
    }

    // Re-mark all items as originally visible (since Boost reconstructed them as visible)
    // but exclude empty bracket items
    allItems.forEach(item => {
      const hasEmptyBrackets = item.querySelector('.boost-sd__filter-option-item-label')?.textContent?.trim() === '[]';

      if (hasEmptyBrackets) {
        item.dataset.originallyVisible = 'false';
        item.style.display = 'none';
      } else {
        item.dataset.originallyVisible = 'true';
        item.dataset.manuallyHidden = 'false';
      }
    });

    // Count eligible items (non-empty bracket items)
    const eligibleItems = Array.from(allItems).filter(item => item.dataset.originallyVisible === 'true');

    if (eligibleItems.length > 5) {
      ul.dataset.seeMoreProcessed = 'true';
      ul.dataset.visibleCount = '5';
      ul.dataset.totalVisibleItems = eligibleItems.length.toString();

      // Apply visibility (show first 5, hide the rest)
      updateVisibilityForVisibleItems(ul, 5);

      // Create new see more button
      createSeeMoreButton(ul);

      // Re-establish DOM reordering watcher
      watchForDOMReordering(ul);
    }
  }

  function processFilterWrappers() {
    const wrappers = document.querySelectorAll('.boost-sd__filter-option-itemwrapper');

    if (wrappers.length === 0) {
      return;
    }

    injectTransitionCSS();

    injectFilterTitle();

    handleSeeMoreButtons();

    wrappers.forEach(wrapper => {
      calculateHeight(wrapper);
    });

    // Monitor Course Area filter for events and changes
    monitorCourseAreaFilter();
  }

  function monitorCourseAreaFilter() {
    // Find the Course Area filter specifically
    const courseAreaFilter = document.querySelector('[data-filteroptionid="pf_m_::asp::course_area"]');

    if (!courseAreaFilter) {
      return;
    }
  }

  let debounceTimer = null;
  const processedWrappers = new WeakSet();

  // Create mutation observer to watch for boost elements and class changes
  const observer = new MutationObserver(mutations => {
    let newElementsFound = false;
    const changedWrappers = new Set();

    mutations.forEach(mutation => {
      // Check for new nodes with boost filter wrappers or filter content
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (
              node.classList?.contains('boost-sd__filter-option-itemwrapper') ||
              node.querySelector?.('.boost-sd__filter-option-itemwrapper')
            ) {
              newElementsFound = true;
            }

            // Check for filter content container
            if (
              node.classList?.contains('boost-sd__filter-tree-vertical-content') ||
              node.querySelector?.('.boost-sd__filter-tree-vertical-content')
            ) {
              // Try to inject title immediately
              setTimeout(() => injectFilterTitle(), 10);
              newElementsFound = true;
            }

            // Check for new filter lists
            if (
              node.classList?.contains('boost-sd__filter-option-listitem') ||
              node.querySelector?.('.boost-sd__filter-option-listitem')
            ) {
              /* eslint-disable no-console */
              console.log('🎯 New filter lists detected in DOM');
              console.log('  Node:', node);
              console.log('  Has listitem class:', node.classList?.contains('boost-sd__filter-option-listitem'));
              console.log('  Contains listitem:', !!node.querySelector?.('.boost-sd__filter-option-listitem'));
              /* eslint-enable no-console */

              // Process see more buttons for new filter lists
              setTimeout(() => {
                /* eslint-disable no-console */
                console.log('⏰ Timeout triggered - processing see more buttons for new lists');
                /* eslint-enable no-console */
                handleSeeMoreButtons();
              }, 500);

              newElementsFound = true;
            }
          }
        });
      }

      // Check for class changes on existing wrappers (collapsed state toggle)
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        mutation.target.classList?.contains('boost-sd__filter-option-itemwrapper')
      ) {
        // Skip if currently transitioning
        if (mutation.target.dataset.heightTransitioning) {
          return;
        }

        // Only process if we haven't already processed this wrapper recently
        if (!processedWrappers.has(mutation.target)) {
          changedWrappers.add(mutation.target);

          // Mark as processed temporarily (shorter duration)
          processedWrappers.add(mutation.target);

          setTimeout(() => {
            processedWrappers.delete(mutation.target);
          }, 50);
        }
      }
    });

    // Process changed wrappers immediately
    changedWrappers.forEach(wrapper => {
      calculateHeight(wrapper);
    });

    // Debounce processing of new elements
    if (newElementsFound) {
      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
        processFilterWrappers();
      }, 50);
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  // Check if elements already exist
  const existingWrappers = document.querySelectorAll('.boost-sd__filter-option-itemwrapper');
  const existingFilterContent = document.querySelector('.boost-sd__filter-tree-vertical-content');

  if (existingWrappers.length > 0) {
    processFilterWrappers();
  } else if (existingFilterContent) {
    // Filter content exists but no wrappers yet, inject title
    injectFilterTitle();
  }

  // Expose debug functions
  window.collectionFilterHandler = {
    processFilterWrappers,
    calculateHeight,
    handleSeeMoreButtons,
    observer,
  };
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', handleCollectionFilters);
} else {
  handleCollectionFilters();
}
